// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"283":"b571ba6966961686","2621":"e032431c16d876c7","2877":"d8f1f07e18dbd62d","3253":"dc497a2a1e5cc530","4591":"5413860106b79c88","7895":"67507bb0e61c2175"}[chunkId] + ".css";
};